<template>
  <div class="recruitmentSystem">
     <v-topBar :yellowPageColumn='yellowPageColumn' :productAndSolutionColumn='productAndSolutionColumn' :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"> </v-topBar>
    <div class="setNavBg">
       <v-header class="hidden-xs hidden-sm" :navigationColumnInfos='navigationColumnInfos' :webConfigInfo='webConfigInfo'  :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"></v-header>
    </div>
    <v-recruitmentBanner :bannerInfo="bannerInfo"></v-recruitmentBanner>
    <div class="recruitmentProcess">
      <div class="processCon clearfix">
        <div class="processLeft col-lg-5 col-md-5 col-sm-12 col-xs-12">
          <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/recruitment_introduction.png" alt="">
        </div>
        <div class="processRight pull-right col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <h4>采购全流程管理</h4>
          <p>围绕企业采购寻源业务，支持招标采购、询报价、电子竞价、直接委托等多种寻源业务形式线上化。</p>
          <p>帮助您的企业对内实现集中管控、降本增效，对外实现高效协作、阳光采购。</p>
          <button type="button" class="btn btn-default btn-lg" @click="centerDialogVisible = true">申请试用</button>
        </div>
      </div>
    </div>
    <div class="valueRealization">
      <v-publiceTit :titleObj="titleObj"></v-publiceTit>
      <v-realizationPublic :realizationInfo="realizationInfo"></v-realizationPublic>
    </div>
    <el-dialog
      title=""
      custom-class="experienceDialog"
      :visible.sync="centerDialogVisible"
      width="30%"
      center>
      <p class="hotline">如需更好的了解一链采购供应链数智化系统，寻求更多采购供应链解决方案，入驻成为平台采购商，请您填写以下信息，或拨打免费服务热线：<span>0516-87796393</span></p>
      <el-form :model="ruleForm" :rules="rules" ref="recruitForm" label-width="92px" class="demo-ruleForm">
        <!--<el-form-item label="角色" prop="roleName">-->
          <!--<el-select v-model="ruleForm.roleName" placeholder="请输入角色">-->
            <!--<el-option-->
              <!--v-for="item in options"-->
              <!--:key="item.value"-->
              <!--:label="item.label"-->
              <!--:value="item.value">-->
            <!--</el-option>-->
          <!--</el-select>-->
        <!--</el-form-item>-->
<!--        <el-form-item label="角色" prop="roleName">-->
<!--          <el-radio-group v-model="ruleForm.roleName">-->
<!--            <el-radio v-for="item in options" :label="item.value" :key="item.value">{{item.label}}</el-radio>-->
<!--          </el-radio-group>-->
<!--        </el-form-item>-->
        <el-form-item label="姓名" prop="userName">
          <el-input v-model="ruleForm.userName" placeholder="请输入姓名" :maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="职位" prop="positionName">
          <el-input v-model="ruleForm.positionName" placeholder="请输入职位" :maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="contractPhone">
          <el-input v-model="ruleForm.contractPhone" placeholder="请输入联系电话" :maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="公司名称" prop="companyName">
          <el-input v-model="ruleForm.companyName" placeholder="请输入公司名称" :maxlength="50"></el-input>
        </el-form-item>
<!--        <el-form-item label="试用平台" prop="trialPlatform">-->
<!--          <el-checkbox-group v-model="ruleForm.trialPlatform" @change="handleChange">-->
<!--            <el-checkbox label="采招平台" ></el-checkbox>-->
<!--            <el-checkbox label="协同平台" ></el-checkbox>-->
<!--            <el-checkbox label="供应商管理" ></el-checkbox>-->
<!--            <el-checkbox label="征信产品" ></el-checkbox>-->
<!--          </el-checkbox-group>-->
<!--        </el-form-item>-->

<!--        <p style="text-align: center;"> <i style="color: #f56c6c;">*</i> 贵公司希望通过一链网，解决当前采购遇到的哪些问题？</p>-->
<!--        // -->

        <div class="clearfix">
          <div class="trialPlatform-label pull-left">
            <i style="color: #f56c6c;">*</i>
            我的需求
            <el-tooltip class="item" effect="dark" content="贵公司希望通过一链网，解决当前采购遇到的哪些问题？" placement="top">
              <el-button type="text" style="vertical-align: middle;">
                <i class="el-icon-question"></i>
              </el-button>
            </el-tooltip>
          </div>
          <div class="pull-left trialPlatform-item" style="width: 300px;font-size: 12px">
            <el-form-item label-width="0" prop="trialPlatform">
              <el-input v-model="ruleForm.trialPlatform"
                        style="font-size: 12px;"
                        type="textarea"
                        :maxlength="100"
                        :show-word-limit="true"
                        placeholder="如 电子招标、供应商管理、合同管理"
                        :autosize="{ minRows: 2, maxRows: 6 }"></el-input>
            </el-form-item>
          </div>
        </div>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm()">提交</el-button>
      </div>
    </el-dialog>
    <v-footer :webConfigInfo='webConfigInfo'  :footerColumnInfos='footerColumnInfos' ></v-footer>
    <v-backToTop></v-backToTop>
  </div>
</template>
<script>
  import header from '@/components/v-header/header'
  import topBar from '@/components/topBar'
  import recruitmentBanner from '@/components/recruitmentBanner'
  import publiceTit from '@/components/publiceTit'
  import realizationPublic from '@/components/realizationPublic'
  import footer from '@/components/v-footer'
  import backToTop from '@/components/backToTop'
  export default {
    props: [],
    data () {
      var checkMobile = (rule, value, callback) => {
        var reg=/^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        var isMob=  /^0\d{2,3}-?\d{7,8}$/;// 座机格式
        if (!reg.test(value)&&!isMob.test(value)) {
          return callback(new Error('请输入有效的联系电话'));
        }else{
          return callback();
        }
      };
      return {
        options: [{
          value: '0',
          label: '采购商'
        }, {
          value: '1',
          label: '供应商'
        }],
        hitSearchUrl:'',
        enterpriseResourceBaseUrl:'',
        yellowPageColumn:{},
        productAndSolutionColumn:{},
        centerDialogVisible: false,
        navigationColumnInfos: [],
        footerColumnInfos: [],
        bannerInfo: {name: '采招系统', eng: 'Recruitment system'},
        titleObj: {name: '为您实现', eng: 'Value realization'},
        realizationInfo: [{title: '全网寻源', content: '招标公告全网露出，一链全网供应商资源'},{title: '在线比价', content: '在线比质比价，一页了然，相机决策，灵活应对市场变化'},{title: '在线风控', content: '支持风控埋点，风险提示让采购过程更阳光、更合规'},{title: '精准推送', content: '大数据＋核心算法支持，全面解锁企业需求，寻源推送更精准'}],
        webConfigInfo: {},
        messageData: [],
        messageTotal:0,
        currentPage:1,
        ruleForm: {
          // roleName: '',
          userName: '',
          positionName: '',
          contractPhone: '',
          companyName: '',
          trialPlatform: ''
        },
        checkList:[],
        rules: {
          // roleName: [
          //   { required: true, message: '请选择角色', trigger: 'change' }
          // ],
          userName: [
            { required: true, message: '请输入姓名', trigger: 'blur' }
          ],
          companyName: [
            { required: true, message: '请输入公司名称', trigger: 'blur' }
          ],
          positionName: [
            { required: true, message: '请输入职位', trigger: 'blur' }
          ],
          contractPhone: [
            { required: true, message: '电话不能为空', trigger: 'blur' },
            { validator: checkMobile, trigger: 'blur' }
          ],
          trialPlatform: [
            { required: true, message: '请输入您的需求', trigger: 'blur' }
          ]
        }
      }
    },
    components: {
      'v-header': header,
      'v-topBar': topBar,
      'v-recruitmentBanner': recruitmentBanner,
      'v-publiceTit': publiceTit,
      'v-realizationPublic': realizationPublic,
      'v-footer': footer,
      'v-backToTop': backToTop
    },
    created () {
      this.$axios.post('/onelink.mdata.main.api/mainInfo/findMainCommonInfo', {
      }).then((res) => {
        this.data = res.data;
        this.webConfigInfo = this.data.webConfigInfoDto;
        this.footerColumnInfos = this.data.footerColumnInfos;
        this.navigationColumnInfos = this.data.navigationColumnInfos;
        this.hitSearchUrl = this.data.hitSearchUrl;
        this.yellowPageColumn = this.data.yellowPageColumn;
        this.productAndSolutionColumn = this.data.productAndSolutionColumn;
        this.enterpriseResourceBaseUrl = this.data.enterpriseResourceBaseUrl;
      }).catch((err) => {
        console.log(err)
      })
    },
    mounted () {
    },
    methods: {
      submitForm() {
        this.$refs['recruitForm'].validate((valid) => {
          if (valid) {
            this.$axios.post('/onelink.mdata.main.api/task/addTaskInfo', {
              taskSource: 0,
              // roleName: this.ruleForm.roleName,
              userName: this.ruleForm.userName,
              positionName:this.ruleForm.positionName,
              contractPhone: this.ruleForm.contractPhone,
              companyName: this.ruleForm.companyName,
              trialPlatform: this.ruleForm.trialPlatform,
              operateStaus: 0
            }).then((res) => {
              this.data = res.data;
              let operateNumber = this.data.data;
              if(res.data.code == '0'){
              // && this.ruleForm.roleName == '1'
                if(this.getToken('isLogin') == ''){
                  if(/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)) {
                    this.$message({
                      dangerouslyUseHTMLString: true,
                      message: '<strong>试用申请已提交,请到PC端, <span style="color:red">三分钟快速注册</span></strong>'
                    });
                    return;
                  } else {
                    this.$message({
                      dangerouslyUseHTMLString: true,
                      message: '<strong>试用申请已提交, <a href="/register" style="color:red">三分钟快速注册</a></strong>'
                    });
                    return;
                  }
                }else{
                  this.$message({
                     message: "试用申请已提交",
                     type: 'success'
                 });
                }
                 this.centerDialogVisible = false;
              }else{
                this.$message({
                     message: "试用提交失败!",
                     type: 'error'
                 });
              }
            }).catch((err) => {
              console.log(err)
            })
          } else {
            return false;
          }
        });
      }
      // ,
      // handleChange(value){
      //   this.ruleForm.trialPlatform = value;
      // }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/recruitmentSystem/index.vue